import { computed } from "vue"
import isMobile from "is-mobile"

export const useIsMobile = () => computed(() => isMobile())
